import { render, staticRenderFns } from "./test.vue?vue&type=template&id=665a8893&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=665a8893&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a8893",
  null
  
)

export default component.exports